// @owners { team: patients }
import { type User } from '~shared/types';

// eslint-disable-next-line sonarjs/no-hardcoded-passwords -- Redux action type constant, not a credential
export const SET_TEMP_PASSWORD = 'SET_TEMP_PASSWORD';

export type ActionSetTempPassword = {
  type: typeof SET_TEMP_PASSWORD;
  payload: string;
};

export function setTempPassword(tempPassword: string): ActionSetTempPassword {
  return {
    type: SET_TEMP_PASSWORD,
    payload: tempPassword,
  };
}

export const SET_INSURANCE_ID = 'SET_INSURANCE_ID';

export type ActionSetInsuranceID = {
  type: typeof SET_INSURANCE_ID;
  payload: number;
};

export function setInsuranceID(insuranceID: number): ActionSetInsuranceID {
  return {
    type: SET_INSURANCE_ID,
    payload: insuranceID,
  };
}

export const SET_EDITING_INSURANCE_ID = 'SET_EDITING_INSURANCE_ID';

export type ActionSetEditingInsuranceID = {
  type: typeof SET_EDITING_INSURANCE_ID;
  payload: number | null;
};

export function setEditingInsuranceID(insuranceID: number | null): ActionSetEditingInsuranceID {
  return {
    type: SET_EDITING_INSURANCE_ID,
    payload: insuranceID,
  };
}

export const SET_INITIAL_ONBOARD_STATE = 'SET_INITIAL_ONBOARD_STATE';

export type ActionSetInitialOnboardState = {
  type: typeof SET_INITIAL_ONBOARD_STATE;
  payload: string;
};

export function setInitialOnboardState(initialOnboardState: string): ActionSetInitialOnboardState {
  return {
    type: SET_INITIAL_ONBOARD_STATE,
    payload: initialOnboardState,
  };
}

export const CLEAR_ONBOARDING_STATE = 'CLEAR_ONBOARDING_STATE';

export type ActionClearOnboardingState = {
  type: typeof CLEAR_ONBOARDING_STATE;
};

export function clearOnboardingState(): ActionClearOnboardingState {
  return {
    type: CLEAR_ONBOARDING_STATE,
  };
}

export const UPDATE_ONBOARDING_USER_SUCCEEDED = 'UPDATE_ONBOARDING_USER_SUCCEEDED';

export type UpdateOnboardingUserSucceeded = {
  type: typeof UPDATE_ONBOARDING_USER_SUCCEEDED;
  payload: User;
};

/**
 * Dispatched by the useUpdateOnboardingUser mutation (React Query) on success so the users reducer
 * upserts the returned user — keeps Redux readers (getCurrentUser, getUserPhiAuth, ...) fresh.
 */
export function updateOnboardingUserSucceeded(user: User): UpdateOnboardingUserSucceeded {
  return {
    type: UPDATE_ONBOARDING_USER_SUCCEEDED,
    payload: user,
  };
}

export const SET_SUCCESS_MESSAGE_TYPE = 'SET_SUCCESS_MESSAGE_TYPE';

export type ActionSetSuccessMessageType = {
  type: typeof SET_SUCCESS_MESSAGE_TYPE;
  payload: string | null | undefined;
};

export function setSuccessMessageType(messageType: string | null | undefined): ActionSetSuccessMessageType {
  return {
    type: SET_SUCCESS_MESSAGE_TYPE,
    payload: messageType,
  };
}
